var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 727,
    height: 522,
    viewBox: "0 0 727 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 349.447,
    cy: 290.089,
    r: 231.911,
    fill: "#F4F4F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.072,
    cy: 133.5,
    r: 14.5357,
    fill: "#F4F4F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.054,
    cy: 31.0893,
    r: 27.0893,
    fill: "#F4F4F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.875,
    cy: 475.089,
    r: 25.7679,
    fill: "#F4F4F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.875,
    cy: 414.304,
    r: 25.7679,
    fill: "#F4F4F4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.661,
    cy: 443.375,
    r: 12.5536,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.882 69.2869C361.303 69.1636 361.303 68.3362 361.882 68.2129L374.389 65.5534C374.6 65.5084 374.766 65.3438 374.811 65.1327L377.502 52.7243C377.627 52.1474 378.45 52.1474 378.575 52.7243L381.266 65.1327C381.312 65.3438 381.477 65.5084 381.688 65.5534L394.195 68.2129C394.774 68.3362 394.774 69.1636 394.195 69.2869L381.688 71.9465C381.477 71.9914 381.312 72.156 381.266 72.3671L378.575 84.7755C378.45 85.3524 377.627 85.3524 377.502 84.7755L374.811 72.3671C374.766 72.156 374.6 71.9914 374.389 71.9465L361.882 69.2869Z",
    fill: "url(#paint0_linear_2250_17)",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3233 304.622C98.5471 303.565 100.056 303.565 100.28 304.622L105.055 327.18C105.136 327.564 105.436 327.866 105.82 327.95L128.118 332.807C129.168 333.036 129.168 334.533 128.118 334.761L105.82 339.619C105.436 339.703 105.136 340.004 105.055 340.389L100.28 362.947C100.056 364.004 98.5471 364.004 98.3233 362.947L93.5485 340.389C93.4671 340.004 93.1675 339.703 92.7831 339.619L70.4851 334.761C69.4356 334.533 69.4356 333.036 70.4851 332.807L92.7831 327.95C93.1675 327.866 93.4671 327.564 93.5485 327.18L98.3233 304.622Z",
    fill: "url(#paint1_linear_2250_17)",
    fillOpacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M557.02 138.122C557.244 137.065 558.753 137.065 558.977 138.122L561.911 151.985C561.993 152.37 562.292 152.671 562.677 152.755L576.404 155.746C577.454 155.974 577.454 157.471 576.404 157.7L562.677 160.691C562.292 160.774 561.993 161.076 561.911 161.461L558.977 175.324C558.753 176.381 557.244 176.381 557.02 175.324L554.086 161.461C554.004 161.076 553.705 160.774 553.32 160.691L539.592 157.7C538.543 157.471 538.543 155.974 539.592 155.746L553.32 152.755C553.705 152.671 554.004 152.37 554.086 151.985L557.02 138.122Z",
    fill: "url(#paint2_linear_2250_17)",
    fillOpacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M609.977 334.793L614.024 353.911L632.868 358.016L614.024 362.121L609.977 381.239L605.931 362.121L587.086 358.016L605.931 353.911L609.977 334.793Z",
    fill: "url(#paint3_linear_2250_17)",
    fillOpacity: 0.55
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M378.173 443.111L276 418.082L394.096 306.111L552 378.563L378.173 443.111Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.023 257.57L172.531 213.785V373.002L276.023 418.114V257.57Z",
    fill: "#E6A352"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M276.023 257.57L172.531 213.785L236.218 192.556L339.71 237.667L276.023 257.57Z",
    fill: "#AC752E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M339.71 237.667L236.218 192.556L309.193 170L415.338 213.785L339.71 237.667Z",
    fill: "#AC752E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.023 257.57L172.531 213.785V373.002L276.023 418.114V257.57Z",
    fill: "#E6A352"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M276.023 257.57L172.531 213.785L236.218 192.556L339.71 237.667L276.023 257.57Z",
    fill: "#AC752E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M339.71 237.667L236.218 192.556L309.193 170L415.338 213.785L339.71 237.667Z",
    fill: "#AC752E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.65 283.754L309 170.111L415 213.718V318.111L311.65 283.754Z",
    fill: "#BC8239"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M415 214.111L276 257.825V418.111L415 373.072V214.111Z",
    fill: "#D59240"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M374.01 187.444L309 170.111L415.139 214.111L443 218.111L374.01 187.444Z",
    fill: "#E8B06D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M241.667 347.111L173 292.14L276 258.111L241.667 347.111Z",
    fill: "#B9874A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128 270.932L172 214.111L276 257.718L237.333 325.111L128 270.932Z",
    fill: "#EDC28E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M309 170.111L172.216 213.814L143 219.111L277.128 176.733L309 170.111Z",
    fill: "#EEAA56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M314.491 354.111L276 258.111L422 288.358L314.491 354.111Z",
    fill: "#B9874A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M322.57 329.111L276 257.236L415.711 214.111L437 282.066L322.57 329.111Z",
    fill: "#EDB46F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2250_17",
    x1: 359.357,
    y1: 68.7499,
    x2: 396.72,
    y2: 68.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2250_17",
    x1: 99.3016,
    y1: 300,
    x2: 99.3016,
    y2: 367.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2250_17",
    x1: 557.998,
    y1: 133.5,
    x2: 557.998,
    y2: 179.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2250_17",
    x1: 609.977,
    y1: 334.793,
    x2: 609.977,
    y2: 381.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131421"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/no-orders.bf3d8aa7920f31dae2393011ec48e1b8.svg";
export { ForwardRef as ReactComponent };